var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.streamKey)?_c('div',{staticClass:"watch-page"},[_c('Stream',{attrs:{"online-users":_vm.onlineUsers,"stream-key":_vm.streamKey,"channel":_vm.channel}}),(true)?_c('ChatOnline',{on:{"on-online-users":_vm.onOnlineUsers}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }